import {
    Button, Grid, Typography, TextField, Box, Hidden
} from "@mui/material";
import { Search as IconSearch, AddCircle as IconAddCircle } from "@mui/icons-material";
import * as direccionService from "../../services/direccionService";
import { useEffect, useState } from "react";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";
import DireccionEdit from "../../components/DireccionEdit";

// Navegabilidad de direcciones con su mantenimiento. El filtro de ubigeo es
// un texto y el listado muestra solo los 50 ultimos registros por fecha de
// registro. El alta se hace con el boton NUEVO, arriba de la tabla.
const Index = () => {
    const { isReadOnly } = useMantenimiento("direccion");

    const [filters, setFilters] = useState({ ubigeo: "", detalle: "" });

    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const [dialog, setDialog] = useState({ open: false, entity: null });
    const openDialog = (entity) => setDialog({ open: true, entity });
    const closeDialog = () => setDialog((d) => ({ ...d, open: false }));

    const fetchResults = async () => {
        setCargando(true);
        try {
            const data = await direccionService.getsDireccionesView();
            let list = data || [];
            if (filters.ubigeo && filters.ubigeo.trim() !== "") {
                const t = filters.ubigeo.toLowerCase();
                list = list.filter((r) => (r.ubigeo || "").toLowerCase().includes(t));
            }
            if (filters.detalle && filters.detalle.trim() !== "") {
                const t = filters.detalle.toLowerCase();
                list = list.filter((r) => (r.detalle || "").toLowerCase().includes(t));
            }
            // Solo los 50 ultimos por fecha de registro.
            list = list
                .slice()
                .sort((a, b) => {
                    const fa = a.fechaRegistro ? new Date(a.fechaRegistro).getTime() : 0;
                    const fb = b.fechaRegistro ? new Date(b.fechaRegistro).getTime() : 0;
                    return fb - fa;
                })
                .slice(0, 50);
            setResults(list);
        } catch (err) {
            console.log("Err: ", err);
            setResults([]);
        }
        setCargando(false);
    };

    useEffect(() => {
        fetchResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const estiloClic = {
        cursor: isReadOnly ? 'default' : 'pointer',
        fontSize: 'inherit',
        textDecoration: isReadOnly ? 'none' : 'underline',
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'ubigeo', headerName: 'Ubigeo', width: 200, sortable: false, headerAlign: 'left' },
        {
            field: 'detalle', headerName: 'Detalle', width: 280, sortable: false, headerAlign: 'left',
            renderCell: (c) => (
                <Typography sx={estiloClic} onClick={isReadOnly ? undefined : () => openDialog(c.row)}>
                    {c.row.detalle}
                </Typography>
            ),
        },
        { field: 'referencia', headerName: 'Referencia', width: 180, sortable: false, headerAlign: 'left' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Direcciones
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    name="ubigeo"
                                    label="Ubigeo"
                                    value={filters.ubigeo}
                                    fullWidth
                                    size="small"
                                    onChange={(e) => setFilters((f) => ({ ...f, ubigeo: e.target.value }))}
                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); fetchResults(); } }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    name="detalle"
                                    label="Detalle"
                                    value={filters.detalle}
                                    fullWidth
                                    size="small"
                                    onChange={(e) => setFilters((f) => ({ ...f, detalle: e.target.value }))}
                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); fetchResults(); } }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={fetchResults}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                showToolbar={true}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconAddCircle />,
                                        disabled: isReadOnly,
                                        onClick: () => openDialog({ id: 0 })
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <DireccionEdit
                    open={dialog.open}
                    openClose={closeDialog}
                    entity={dialog.entity}
                    setNewSaved={fetchResults}
                    isReadOnly={isReadOnly}
                />
            </Grid>
        </div>
    );
};

export default Index;